import apiClient from './apiClient';

export interface ProductShippingMetadata {
  productId: string;
  retailer: string;
  productTitle?: string;
  price?: number;
  weightInKg?: number;
  volumeInCubicInches?: number;
  packageDimensionsJson?: string;
  fixedShippingPrice?: number;
  source: string;
  createdAt: string;
  updatedAt: string;
}

export interface ProductShippingMetadataRequest {
  productId: string;
  retailer: string;
  productTitle?: string;
  price?: number;
  weightInKg?: number;
  volumeInCubicInches?: number;
  packageDimensionsJson?: string;
  fixedShippingPrice?: number;
  source: string;
}

const productShippingMetadataService = {
  getAll: async (searchTerm?: string) => {
    const params = searchTerm ? `?search=${encodeURIComponent(searchTerm)}` : '';
    const response = await apiClient.get(`/admin/product-shipping-metadata${params}`);
    return response.data;
  },

  getByProductIdAndRetailer: async (productId: string, retailer: string) => {
    const response = await apiClient.get(`/admin/product-shipping-metadata/${productId}/${retailer}`);
    return response.data;
  },

  getByRetailer: async (retailer: string, searchTerm?: string) => {
    const params = searchTerm ? `?search=${encodeURIComponent(searchTerm)}` : '';
    const response = await apiClient.get(`/admin/product-shipping-metadata/retailer/${retailer}${params}`);
    return response.data;
  },

  create: async (data: ProductShippingMetadataRequest) => {
    const response = await apiClient.post('/admin/product-shipping-metadata', data);
    return response.data;
  },

  update: async (productId: string, retailer: string, data: ProductShippingMetadataRequest) => {
    const response = await apiClient.put(`/admin/product-shipping-metadata/${productId}/${retailer}`, data);
    return response.data;
  },

  delete: async (productId: string, retailer: string) => {
    const response = await apiClient.delete(`/admin/product-shipping-metadata/${productId}/${retailer}`);
    return response.data;
  },
};

export default productShippingMetadataService;

